import React from 'react';
import PropTypes from 'prop-types';

import styles from 'stylesheets/components/book_club/book_club_header_image_section';
import { useMediaQuery } from 'react-responsive';
import { breakpoints } from 'javascripts/shared/utils/breakpoint_utils';

export function BookClubHeaderImageSection({ mobileImageUrl, desktopImageUrl, altText }) {
  const isMobile = useMediaQuery({ maxWidth: breakpoints.xs });

  return (
    <div className={styles.bookClubHeaderSection}>
      <img
        alt={altText}
        className={styles.bookClubHeaderImage}
        src={isMobile ? mobileImageUrl : desktopImageUrl}
      />
    </div>
  );
}

BookClubHeaderImageSection.propTypes = {
  altText: PropTypes.string,
  desktopImageUrl: PropTypes.string,
  mobileImageUrl: PropTypes.string
};
